export default {"src":"/_next/static/media/ic-word.4c8cde64.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};